import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en';
import 'dayjs/locale/it';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);

const dateHandler = {
  checkIsBefore(d1, d2) {
    return dayjs(d1).isBefore(dayjs(d2));
  },
  checkIsSame(d1, d2, unit = undefined) {
    return dayjs(d1).isSame(d2, unit);
  },
  getFormattedDate(date, style = 'DD/MM/YY') {
    return dayjs(date).format(style);
  },
  getFormattedDifference(d1, d2) {
    // Use from() method instead of duration to properly show direction
    // This correctly shows "20 ore fa" (20 hours ago) for past events
    // and "tra 20 ore" (in 20 hours) for future events
    return dayjs(d1).locale(dayjs.locale()).from(dayjs(d2));
  },
  getSubtractedDate(amount, unit) {
    return dayjs().subtract(amount, unit).utc().format();
  },
  getUtcDate(date) {
    return dayjs(date).utc().format();
  },
  parseUnbondingTime(unbondingTimeString) {
    if (!unbondingTimeString || typeof unbondingTimeString !== 'string') {
      return null;
    }

    const match = unbondingTimeString.match(/^(\d+)s$/);
    if (!match) {
      return null;
    }

    return parseInt(match[1], 10);
  },
  formatUnbondingDuration(unbondingTimeString) {
    const seconds = this.parseUnbondingTime(unbondingTimeString);

    if (seconds === null) {
      return '-';
    }

    // Duration objects don't inherit global locale automatically
    // We must explicitly set the locale on the duration object
    const dur = dayjs.duration(seconds, 'seconds');
    const loc = dayjs.locale();
    return dur.locale(loc).humanize();
  },
  /**
   * Set the locale for dayjs globally.
   * This affects all date formatting operations including humanize().
   * @param {string} locale - The locale code (e.g., 'en', 'it')
   */
  setLocale(locale) {
    try {
      dayjs.locale(locale);
    } catch (error) {
      // Fallback to English if locale is not supported
      console.warn(
        `Locale "${locale}" not supported by dayjs, falling back to "en"`
      );
      dayjs.locale('en');
    }
  },
};

export default dateHandler;
